import React, { useEffect, useState } from "react";
import ReusableTable from "../../../../components/common/table";
import { Button, Popconfirm, Space } from "antd";
import { ReactComponent as AddSvg } from "../../../../assets/images/add.svg";
import FilterComponent from "../../../../components/common/filter";
import { useNavigate, useSearchParams } from "react-router";
import ConfirmModal from "../../../../components/common/alert-popup";
import { ReactComponent as ViewSvg } from "../../../../assets/images/action/view.svg";
import { ReactComponent as DeleteSvg } from "../../../../assets/images/action/delete.svg";
import { ReactComponent as EditSvg } from "../../../../assets/images/action/edit.svg";
import { ReactComponent as DisableSvg } from "../../../../assets/images/action/Shield Cross.svg";
import CommonFilter from "../../../../components/common/filter";
import trimSearchValue, { useDebounce } from "../../../../customHooks";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteAuthor,
  listAuthors,
  updateAuthor,
} from "../../../../redux/reducer/authorSlice";
import { toast } from "react-toastify";

const ManageAuthors = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [modalConfig, setModalConfig] = useState({
    open: false,
    actionType: "",
  });
  const [refereshData, setRefereshData] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [disableId, setDisableId] = useState(null);
  // set page refersh
  const [searchParams, setSearchParams] = useSearchParams();
  // Convert URLSearchParams to usable object
  const getInitialParams = () => {
    const page = parseInt(searchParams.get("page")) || 1;
    const size = parseInt(searchParams.get("size")) || 10;
    const search_key = searchParams.get("search_key") || "all";
    const search_value = searchParams.get("search_value") || "";
    const status = searchParams.get("status");
    const type = searchParams.get("type");
    const position = searchParams.get("position");

    return {
      page,
      size,
      search_key,
      search_value,
      status: status !== null ? Number(status) : undefined,
      type: type !== null ? Number(type) : undefined,
      position: position !== null ? Number(position) : undefined,
    };
  };

  const [tableParams, setTableParams] = useState(getInitialParams());

  const debouncedSearchValue = useDebounce(tableParams.search_value, 500);

  useEffect(() => {
    dispatch(listAuthors(trimSearchValue(tableParams)));
  }, [
    dispatch,
    refereshData,
    tableParams.page,
    tableParams.size,
    debouncedSearchValue,
    tableParams.status,
  ]);

  const showModal = (actionType) => {
    setModalConfig({ open: true, actionType });
  };

  const closeModal = () => {
    setModalConfig({ open: false, actionType: "" });
  };
  const { listAuthorData, listAuthorCount, listAuthorLoading } = useSelector(
    (state) => state?.author
  );


  const columns = [
    {
      title: "SR. NO.",
      dataIndex: "sr_no",
      key: "SR. NO.",
      width: "80px",
      render: (text, record, index) =>
        (tableParams.page - 1) * tableParams.size + index + 1,
    },
    {
      title: "Author Name",
      dataIndex: "name",
      key: "name",
      width: "150px",
      type: "search",
    },
    {
      title: "About the author",
      dataIndex: "about_en",
      key: "about_en",
      width: "250px",
      // type: "search",
      render: (short_desc_en) =>
        short_desc_en
          ? `${short_desc_en?.slice(0, 25)} ${
              short_desc_en?.length > 25 ? "..." : ""
            }`
          : "",
    },
    {
      title: "Image",
      dataIndex: "image_url",
      key: "image_url",
      render: (book_cover_en) => (
        <div>
          {book_cover_en ? (
            <img
              src={`${process.env.REACT_APP_IMAGE_URL}/${book_cover_en}`}
              alt="Banner"
              style={{
                width: "100px",
                height: "50px",
                objectFit: "contain",
                borderRadius: "8px",
              }}
            />
          ) : (
            "No Image"
          )}
        </div>
      ),
    },
    {
      title: "Date Added",
      dataIndex: "created_at",
      key: "created_at",
      // type: "date",
      render: (date) => {
        const dateObject = new Date(date);
        const day = String(dateObject.getUTCDate()).padStart(2, "0");
        const month = String(dateObject.getUTCMonth() + 1).padStart(2, "0");
        const year = dateObject.getUTCFullYear();
        return `${month}-${day}-${year}`;
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      type: "select",
      width: "90px",
      render: (status) =>
        status === 1 ? (
          <p className="active-status">Active</p>
        ) : (
          <p className="inactive-status">Inactive</p>
        ),
      options: [
        { label: "Active", value: 1 },
        { label: "Inactive", value: 0 },
      ],
    },
  ];

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    showModal("delete");
  };

  const actionItems = (record) => [
    {
      key: "edit",
      label: (
        <>
          <EditSvg style={{ marginRight: 8, color: "red" }} />
          Edit Details
        </>
      ),
      onClick: (record) => navigate(`edit-author/${record?.id}`),
    },
    {
      key: "disable",
      label: (
        <>
          <DisableSvg
            style={{
              marginRight: 8,
              color: `${record.status === 1 ? "green" : "red"}`,
            }}
          />
          {record.status === 1 ? "Disable" : "Enable"}
        </>
      ),
      onClick: (record) => handleDisableClick(record.id, record?.status),
    },
    {
      key: "delete",
      label: (
        <>
          <DeleteSvg style={{ marginRight: 8, color: "red" }} />
          Delete Author
        </>
      ),
      onClick: (record) => handleDeleteClick(record.id),
    },
  ];

  const handleConfirm = async () => {
    try {
      if (modalConfig.actionType === "delete" && deleteId) {
        await dispatch(deleteAuthor(deleteId));
      } else if (modalConfig.actionType === "disable" && disableId) {
        await dispatch(updateAuthor({ id: disableId, data: { status: 0 } }));
      } else if (modalConfig.actionType === "enable") {
        await dispatch(updateAuthor({ id: disableId, data: { status: 1 } }));
      }
    } catch (error) {
      console.error("Action failed:", error);
    } finally {
      setRefereshData((prev) => !prev);
      setDisableId(null);
    }
    closeModal();
  };

  const handleDisableClick = (id, status) => {
    if (status === 1) {
      showModal("disable", id, status);
    } else if (status === 0) {
      showModal("enable", id, status);
    } else {
    }
    // setDisableStatus(status);
    setDisableId(id);
  };
  const handleFilterChange = (key, value, reset = false) => {
    setTableParams((prev) => {
      if (reset) {
        return {
          ...prev,
          search_key: "",
          search_value: "",
          status: undefined,
          position: undefined,
        };
      } else if (key === "status" || key === "type" || key === "position") {
        return {
          ...prev,
          [key]: value === 0 ? 0 : value === 1 ? 1 : undefined,
          search_key: undefined,
          search_value: undefined,
        };
      }
      return {
        ...prev,
        search_key: key,
        search_value: value,
        status: undefined,
        position: undefined,
      };
    });
  };
  const paginationConfig = {
    pageSizeOptions: ["10", "20", "50"],
    showSizeChanger: true,
    showQuickJumper: true,
    total: listAuthorCount || 1,
    current: tableParams.page,
    pageSize: tableParams.size,
    type: tableParams.type,
    onChange: (page, pageSize) => {
      // setCurrentPage(page);
      setTableParams((prev) => ({ ...prev, page, size: pageSize }));
    },
  };

  const handleTableChange = (pagination) => {
    setTableParams((prev) => ({
      ...prev,
      page: pagination.current,
      size: pagination.pageSize,
    }));
  };

  return (
    <div>
      <div className="addBx">
        <div className="filterBx">
          <Space>
            <CommonFilter
              columns={columns}
              onFilterChange={handleFilterChange}
              searchValue={tableParams.search_value}
            />
          </Space>
        </div>
        <Button
          type="primary"
          icon={<AddSvg />}
          onClick={() => navigate("add-authors")}
        >
          Add Authors
        </Button>
      </div>
      <div className="tableHeading">List of Authors Added</div>
      <ReusableTable
        columns={columns}
        dataSource={listAuthorData ?? []}
        loading={listAuthorLoading}
        actionItems={(record) => actionItems(record)}
        paginationConfig={paginationConfig}
        onChange={handleTableChange}
      />
      <ConfirmModal
        titlePrefix="Author"
        messagePrefix="Author"
        open={modalConfig.open}
        onClose={closeModal}
        onConfirm={handleConfirm}
        actionType={modalConfig.actionType}
      />
    </div>
  );
};

export default ManageAuthors;
